import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"

import { media } from "css/breakpoints"
import { fullGrid, grid } from "css/grid"

import useConstant from "hooks/useConstant"

import Image from "components/media/ImageCLD"
import PopinButton from "components/popin-edito/PopinButton"
import { getTemplate } from "../utils"
import { SubBlock, Heading, Chapo, Paragraph, txtAlignMobile } from "../TextBlock"

const Root = styled.section`
  ${fullGrid}
`

const Container = styled.div`
  grid-column: doc;
  ${fullGrid}

  /* height: 100vh; */

  & picture {
    grid-column: doc;
    grid-row: 1;
  }

  & img {
    grid-column: doc;

    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const TextsContainer = styled.div`
  grid-row: 1;
  grid-column: main;
  ${grid}
  grid-template-rows: 7vw [txt-start] auto [txt-end] 7vw;

  & > div {
    position: relative;
  }
`

function Slide({ media, heading, chapo, paragraph, align, align_mobile, theme, popin_button }) {
  const console = useConsole()

  const txtTheme = theme?.theme || "dark-theme"
  const alignMobile = txtAlignMobile[align_mobile || "start"]

  const isText = heading || chapo || paragraph?.length || popin_button

  return (
    <Container>
      <Image {...media} />
      {isText && (
        <TextsContainer>
          <SubBlock className={`${align} ${txtTheme} ${alignMobile}`}>
            <Heading {...heading} />
            {chapo ? <Chapo txt={chapo} /> : null}
            {paragraph.length ? paragraph.map((p, i) => <Paragraph key={`txt-block-paragraph-${i}`} txt={p} />) : null}
            {popin_button ? <PopinButton {...popin_button} /> : null}
          </SubBlock>
        </TextsContainer>
      )}
    </Container>
  )
}

export default function ScrollerPassive({ text_stop, image_sequence, ...props }) {
  const console = useConsole()

  // const env = useEnv()

  // const sources = useConstant(
  //   () =>
  //     new Map([
  //       ["portrait", image_sequence.first_frame_cld.sources.find(o => o.media === media.portrait)],
  //       ["landscape", image_sequence.first_frame_cld.sources.find(o => o.media === media.landscape)],
  //     ])
  // )

  // const medias = text_stop.length
  //   ? text_stop.map(item => {
  //       return {
  //         sources: [
  //           { media: media.portrait, src: getTemplate(true, first_frame_cld, env).replace("%", `${item.end.toString().padStart(4, "0")}`) },
  //           { media: media.landscape, src: getTemplate(false, first_frame_cld, env).replace("%", `${item.end.toString().padStart(4, "0")}`) },
  //         ],
  //       }
  //     })
  //   : [
  //       {
  //         sources: [
  //           { media: media.portrait, src: getTemplate(true, first_frame_cld, env).replace("%", `${image_sequence.end.toString().padStart(4, "0")}`) },
  //           { media: media.landscape, src: getTemplate(false, first_frame_cld, env).replace("%", `${image_sequence.end.toString().padStart(4, "0")}`) },
  //         ],
  //       },
  //     ]

  return (
    <Root>
      {text_stop.length ? (
        text_stop.map((item, i) => <Slide key={`slide-${i}`} media={image_sequence.first_frame_cld} {...item} />)
      ) : (
        <Slide media={image_sequence.first_frame_cld} {...image_sequence.first_frame_cld} />
      )}
    </Root>
  )
}
